import $ from 'jquery';

$('.footer-ttop').click(function () {
  $('html, body').animate({ scrollTop: 0 }, 500);
  return false;
});
